
import { create } from "zustand";

interface Claim {
  claim_id: string;
  policy_number: string;
  claimant_name: string;
  status: string;
  assigned_to: string;
  created_on?: string;
  updated_on?: string;
}

interface StatusCounts {
  DRAFT: number;
  NEW: number;
  ASSESSED: number;
  APPROVED: number;
  REJECTED: number;
  [key: string]: number;
}

interface ClaimStore {
  claims: Claim[];
  filteredClaims: Claim[] | null;
  searchedClaim: Claim[] | null;
  statusCounts: StatusCounts | null;
  assignmentDetails: string | null; 
  setClaims: (claims: Claim[]) => void;
  setFilteredClaims: (claims: Claim[] | null) => void;
  setSearchedClaim: (claim: Claim[] | null) => void;
  setStatusCounts: (counts: StatusCounts) => void;
  setAssignmentDetails: (assigned: string | null) => void;
}

export const useClaimDetailsStore = create<ClaimStore>((set) => ({
  claims: [],
  filteredClaims: null,
  searchedClaim: null,
  statusCounts: null,
  assignmentDetails: null,
  setClaims: (claims) => set({ claims }),
  setFilteredClaims: (claims) => set({ filteredClaims: claims }),
  setSearchedClaim: (claim) => set({ searchedClaim: claim }),
  setStatusCounts: (counts) => set({ statusCounts: counts }),
  setAssignmentDetails: (assigned) => set({ assignmentDetails: assigned }),
}));
